module.exports = __webpack_public_path__ + "img/SignUpPic.36d8be7f.png";